import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxLockedPlayersSalaryValidator extends BaseValidator {
    private maxSalary: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.maxSalary = sportConfig.getConfigProp('maxSalary', 0);

        if (this.isSalaryExceeded()) {
            this.addError('The total salary of your locked players exceeds the salary cap, please adjust.');
        }
    }

    private isSalaryExceeded(): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const lockedPlayersSalary = this.calcLockedPlayersSalary();

        return this.maxSalary <= lockedPlayersSalary;
    }

    private calcLockedPlayersSalary(): number {
        // @ts-ignore
        const {players, playersLock} = this.dependencies;

        let salary = 0;
        playersLock.getMergedLockedPlayerIds().map((playerId) => {
            const player = players.getPlayer(playerId);
            if (player !== null) {
                salary += player.salary;
            }
        });

        return salary;
    }
}

export {MaxLockedPlayersSalaryValidator};
